<!--
@author ab557z
-->
<template>
  <li :id="'cli' + i" class="list-group-item votingCandidate" style="">
           <input class="votingInputBox" v-model="selected" type="text" :id="'candidateBox'+i" :name="'candidateBox'+i"/>
           <input type="hidden" :name="'candidate'+i" :value="candidate.candidateId"/>
            <label style="margin-bottom:0px;color:#494949;" :for="'candidateBox'+i">{{candidate.name}}</label><br>
            <a class="purpleLink" title="Manifesto" v-if="candidate.manifestoLink" :href="candidate.manifestoLink" target="_blank">Manifesto</a>
          </li>
</template>

<script>
// import $ from 'jquery'

export default {
  name: 'Candidate',
  props: ['i', 'candidate'],
  methods: {

  },
  watch: {
    selected: function () {
      if (this.selected.length > 0) {
        document.getElementById('cli' + this.i).setAttribute('style', 'background-color:rgba(149, 18, 114, 0.1);')
      } else {
        document.getElementById('cli' + this.i).removeAttribute('style', 'background-color:rgba(149, 18, 114, 0.1);')
      }
    }
  },
  data () {
    return {
      selected: ''
    }
  }
}
</script>
<style>

</style>
